<template>
    <div class="message-info">
        <mt-header fixed title="报警详情">
            <router-link slot="left" to>
                <mt-button icon="back"  @click="$router.back(-1)">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-field label="报警老人"  v-model="elderName" readonly></mt-field>
            <mt-field label="所属服务点"  v-model="stationName" readonly></mt-field>
            <mt-field label="报警地址" type="textarea" rows="2" v-model="alarmAddress" readonly></mt-field>
            <mt-field label="报警时间"  v-model="alarmTime" readonly></mt-field>
            <mt-field label="状态"  v-model="status" readonly></mt-field>

            <a class="mint-cell mint-field" :href="'tel:'+elderPhone" @click.stop><!---->
                <div class="mint-cell-left"></div>
                <div class="mint-cell-wrapper">
                    <div class="mint-cell-title"><!---->
                        <span class="mint-cell-text">联系电话</span> <!---->
                    </div>
                    <div class="mint-cell-value">
                        <input type="text" readonly="readonly" :value="elderPhone" class="mint-field-core">
                    </div>
                </div>
                <div class="mint-cell-right"></div>
            </a>

            <a class="mint-cell mint-field" :href="'tel:'+sosPhone1" @click.stop><!---->
                <div class="mint-cell-left"></div>
                <div class="mint-cell-wrapper">
                    <div class="mint-cell-title"><!---->
                        <span class="mint-cell-text">手环紧急联系号码1</span> <!---->
                    </div>
                    <div class="mint-cell-value">
                        <input type="text" readonly="readonly" :value="sosPhone1" class="mint-field-core">
                    </div>
                </div>
                <div class="mint-cell-right"></div>
            </a>

            <a class="mint-cell mint-field" :href="'tel:'+sosPhone2" @click.stop><!---->
                <div class="mint-cell-left"></div>
                <div class="mint-cell-wrapper">
                    <div class="mint-cell-title"><!---->
                        <span class="mint-cell-text">手环紧急联系号码2</span> <!---->
                    </div>
                    <div class="mint-cell-value">
                        <input type="text" readonly="readonly" :value="sosPhone2" class="mint-field-core">
                    </div>
                </div>
                <div class="mint-cell-right"></div>
            </a>

            <mt-field label="处理结果" type="textarea" rows="4" v-model="handleContent"></mt-field>

            <div class="new-form-button" v-if="status_id === 0">
                <mt-button size="large" type="primary" @click="handle()">确定处理</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                id:this.$route.params.id,
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
              //  openid:'oh_QtwdMN2NBKkGDyQUXXbdWTA7I',

                elderName:'',
                stationName:'',
                elderPhone:'',
                sosPhone1:'',
                sosPhone2:'',
                alarmAddress:'',
                alarmTime:'',
                handleContent:'',
                status:'',
                status_id:-1
            }
        },

        created(){
            this.$axios.get('/alarm/detail?openid='+this.openid+'&id='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {
                        let r = data.data.data;
                        console.log(r);
                        this.elderName = r.elder.name;
                        this.elderPhone = r.elder.phone;
                        this.stationName = r.station.name;
                        this.sosPhone1 = r.app_watch_phone.sos_phone1;
                        this.sosPhone2 = r.app_watch_phone.sos_phone2;
                        this.alarmAddress = r.alarm_address;
                        this.alarmTime = r.created_at;
                        this.status = r.status_name;
                        this.status_id = r.status;
                        this.handleContent = r.handle_content;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },

        methods:{
            handle(){
                if(this.handleContent === ''){
                    this.$toast('请输入处理结果');
                    return false;
                }

                this.$indicator.open('加载中');
                this.$axios.post("/alarm", {openid:this.openid,id:this.id,handle_content:this.handleContent})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('处理成功!');
                            let that = this;
                            setTimeout(function(){
                                that.$router.push('/alarm');
                            },1000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/alarm/alarmInfo.vue